export default __webpack_public_path__ + "static/media/img-sim.c4f243e8.png";